import React from 'react'
import { Box, Button } from 'rebass/styled-components'
import PropTypes from 'prop-types'

const Burger = ({ onClick, open }) => {
  return (
    <Button
      open={open}
      onClick={onClick}
      height="24px"
      width="24px"
      bg="transparent"
      p={0}
      sx={{
        position: 'relative',
        zIndex: '10',
        border: 'none',
        cursor: 'pointer',
        boxShadow: 'none',

        '&:focus': {
          outline: 'none'
        },

        '@media (min-width: 80rem)': {
          display: 'none'
        },

        '& div': {
          width: '18px',
          position: 'relative',
          display: 'block',
          height: '2px',
          bg: 'black',
          mb: '5px',
          zIndex: '1',
          transformOrigin: '4px 0px',
          transition: 'transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0), opacity 0.55s ease',

          '&': open && {
            opacity: '1',
            transform: 'rotate(45deg) translate(-2px, -1px)'
          },

          '&:nth-child(3)': open && {
            opacity: '0',
            transform: 'rotate(0deg) scale(0.2, 0.2)'
          },

          '&:nth-child(2)': open && {
            transform: 'rotate(-45deg) translate(0, -1px)'
          }
        }
      }}
    >
      <Box
        sx={{
          transformOrigin: '0% 0%'
        }}
      />
      <Box />
      <Box
        sx={{
          transformOrigin: '0% 100%'
        }}
      />
    </Button>
  )
}

Burger.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool
}

export default Burger
